import {useContaCommand} from '@/commandbar/commandBar.service'
import {CUSTOMER, SUPPLIER} from '@/subaccount/types/SubAccount'
import {showNewSubAccountPopup} from '@/subaccount/subAccount.service'

const {registerCommand} = useContaCommand()


const newCustomer = {
    type: 'subaccount',
    typeLabel: 'Kunde',
    label: 'Ny kunde',
    key: 'new-customer',
    //TODO: validate if this is used in cypress?
    ['data-cy']: 'new-subaccount-button',
    icon: 'i-ph-user-plus-fill',
    activate: () => showNewSubAccountPopup({relationType: CUSTOMER}),
    isActive: () => false
}
registerCommand(newCustomer)

const newSupplier = {
    type: 'subaccount',
    typeLabel: 'Leverandør',
    label: 'Ny leverandør',
    key: 'new-supplier',
    //TODO: validate if this is used in cypress?
    ['data-cy']: 'new-supplier-button',
    icon: 'i-ph-truck-fill',
    activate: () => showNewSubAccountPopup({relationType: SUPPLIER, isBusiness: true}),
    isActive: () => false
}
registerCommand(newSupplier)
